/** Feature flags (STORY-099): evaluated on the server for the caller; the client only reads. */
import { useQuery } from "@tanstack/react-query";

import { getFlags } from "../teacher/api";

export function useFlags(): Record<string, boolean> {
  const q = useQuery({ queryKey: ["flags"], queryFn: getFlags, staleTime: 60_000, retry: false });
  return q.data?.flags ?? {};
}
